<template>
  <div>
    <h2 class="content-block">Upload statement</h2>
    <div class="dx-fieldset">
      <div class="dx-field">
        <div class="dx-field-label">Statement Source:</div>
        <DxDropDownBox
          :value.sync="selectedStatementSource"
          :opened.sync="isDropDownBoxOpened"
          display-expr="name"
          placeholder="Select statement source"
		  width="50%"
		  :data-source="statementSourcesDataSource"
        >
          <DxList
            :data-source="statementSourcesDataSource"
            display-expr="name"
            selection-mode="single"
            @selection-changed="changeDropDownBoxValue($event)"
          >
          </DxList>
        </DxDropDownBox>
      </div>
      <div v-if="!!selectedStatementSource" class="dx-field">
        <div class="dx-field-label">Statement format:</div>
        <div class="dx-field-value">
          {{
            statementFormatLookup[
              selectedStatementSource.currentStatementFormatId
            ].name
          }}
        </div>
      </div>
      <div class="fileuploader-container">
        <DxFileUploader
          select-button-text="Select Statement"
          icon="file"
          label-text="Pick a statement or drag a file here"
          upload-mode="instantly"
          :upload-url="uploadUrl"
          :visible="!!selectedStatementSource"
          @uploaded="uploadFinished"
          @uploadStarted="uploadStarted"
        />
      </div>
      <div v-if="!!uploadSuccessStatementId" class="dx-field">
        <div class="dx-field-label">Upload success</div>
        <DxButton
          icon="arrowright"
          text="View uploaded statement"
          @click="viewUploadedStatement"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { DxFileUploader } from 'devextreme-vue/file-uploader'
//import {DxTextBox} from 'devextreme-vue/text-box';
import { DxButton } from 'devextreme-vue/button'
import DxList from 'devextreme-vue/list'
import { DxDropDownBox } from 'devextreme-vue'
import ArrayStore from 'devextreme/data/array_store'
import DataSource from 'devextreme/data/data_source'
import { mapState } from 'vuex'
import { prefixHttp } from '@/utils/http'
import { config } from '@/config'

export default {
  name: 'ViewUploadStatement',
  components: {
    DxFileUploader,
    //DxTextBox,
    DxButton,
    DxDropDownBox,
    DxList,
  },
  data() {
    return {
      config,
      loading: false,
      selectedStatementSource: null,
      statementSourcesDataSource: null,
      isDropDownBoxOpened: false,
      uploadUrl: null,
      uploadSuccessStatementId: null,
    }
  },
  computed: {
    ...mapState('user', ['statementSources', 'statementFormatLookup']),
  },

  created() {
    this.statementSourcesDataSource = new DataSource({
      store: new ArrayStore({
        key: 'id',
        data: this.statementSources
		.sort(compare)
		.filter(
          (statementSource) =>
            this.statementFormatLookup[statementSource.currentStatementFormatId]
              .allowManualUpload,
        ),
      }),
    })
	function toLower(value) {
		return value.name.toLowerCase().trim();
    }
	function compare(a, b) {
		if (toLower(a) < toLower(b)) return -1;
		if (toLower(a) > toLower(b)) return 1;
		return 0;
	}
  },
  destroyed() {
    this.statementSourcesDataSource.dispose()
  },
  methods: {
    changeDropDownBoxValue(e) {
      this.selectedStatementSource = e.addedItems[0]
      this.isDropDownBoxOpened = false
      this.uploadUrl =
        prefixHttp +
        'reconciliation/admin/statement/upload/' +
        this.selectedStatementSource.id +
        '?statementFormat=' +
        this.selectedStatementSource.currentStatementFormatId
    },
    viewUploadedStatement() {
      this.$router.push({
        path: `/statement/${this.uploadSuccessStatementId}`,
      })
    },
    uploadStarted() {
      this.uploadSuccessStatementId = null
    },
    uploadFinished(e) {
      this.uploadSuccessStatementId = JSON.parse(
        e.request.responseText,
      ).importedStatement.id
    },
  },
}
</script>
<style lang="scss"></style>
